import PropTypes from 'prop-types';
import React from 'react';
import { Alert, Progress, Spin, Table } from 'antd';
import { withTranslation } from 'react-i18next';

import BatchStats from './stats';
import './styles.scss';

const ValidationSummary = ({ validated, rows, balance, summaryColumns, t }) => {
  if (validated.length < 1) {
    return '';
  }

  const errors = validated.filter(({ valid }) => !valid);

  const elem = (
    <Progress
      className="progress"
      size="small"
      type="dashboard"
      percent={Math.floor((validated.length * 100) / rows.length)}
    />
  );

  return (
    <Spin indicator={elem} size="large" spinning={validated.length < rows.length}>
      <BatchStats
        items={validated}
        processed={0}
        balance={balance || null}
      />
      {(!!errors.length) ? (
        <Table
          rowKey={(r, i) => i}
          columns={summaryColumns}
          dataSource={errors}
          pagination={false}
          scroll={{ x: true }}
        />
      ) : (
        <Alert
          message="Batch details"
          description={t('batch.info1')}
          type="info"
          showIcon
        />
      )}
    </Spin>
  );
};

ValidationSummary.propTypes = {
  balance: PropTypes.string,
  rows: PropTypes.array,
  summaryColumns: PropTypes.array,
  t: PropTypes.func,
  validated: PropTypes.array,
};

export default withTranslation()(ValidationSummary);
